import {Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import {Button} from "@progress/kendo-react-buttons";

const ConfirmRecalculate = props => {
    return(
        <>


            <Dialog title={"Please confirm"} onClose={props.cancel}
                    height={250}
                    width={400}
            >
                <p
                    style={{
                        margin: "25px",
                        textAlign: "center",
                    }}
                >
                    {props.text}
                </p>
                <DialogActionsBar>

                    <Button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={props.actionAll}
                        themeColor={"error"}
                        style={{height:"40px"}}
                    >
                        All
                    </Button>

                    <Button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={props.actionUnInvoiced}
                        themeColor={"warning"}
                        style={{height:"40px"}}
                    >
                        Non-Invoiced
                    </Button>

                    <Button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={props.cancel}
                        themeColor={"success"}
                        style={{height:"40px"}}
                    >
                        Cancel
                    </Button>

                </DialogActionsBar>
            </Dialog>



        </>
    )
}

export default ConfirmRecalculate